import React from "react";
import { StartChatListing } from "screens/StartChat/StartChatListing/StartChatListing";

const StartChatPage = () => {
  return <StartChatListing />;
};

export default StartChatPage;
